import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { MessageSquare, Lightbulb, Info } from "lucide-react";
import { LevelSetQuestion } from "./questionTypes";

interface LevelSetScreenProps {
  question: LevelSetQuestion;
  onNext: () => void;
}

const iconMap = {
  'chat': MessageSquare,
  'lightbulb': Lightbulb,
  'info': Info,
};

export function LevelSetScreen({ question, onNext }: LevelSetScreenProps) {
  return (
    <div className="max-w-4xl mx-auto px-4 pt-8 pb-4">
      <div className="space-y-4">
        {question.sections.map((section, index) => {
          const IconComponent = iconMap[section.icon as keyof typeof iconMap] || Info;
          
          return (
            <Card key={index} className="p-4 border border-border/50 bg-card/50 backdrop-blur-sm">
              <div className="flex items-start gap-4">
                <div className="flex-shrink-0">
                  <div className="w-8 h-8 rounded-lg bg-primary/10 flex items-center justify-center">
                    <IconComponent className="w-5 h-5 text-primary" />
                  </div>
                </div>
                <div className="flex-1 space-y-3">
                  <h3 className="text-lg font-semibold text-foreground">
                    {section.title}
                  </h3>
                  <div className="text-muted-foreground leading-relaxed">
                    {section.content.split('\n').map((line, lineIndex) => {
                      if (line.startsWith('•')) {
                        return (
                          <div key={lineIndex} className="flex items-start gap-2 mt-2">
                            <div className="w-2 h-2 rounded-full bg-primary/60 mt-2 flex-shrink-0" />
                            <span className="text-sm">{line.substring(1).trim()}</span>
                          </div>
                        );
                      }
                      return (
                        <p key={lineIndex} className={`text-sm ${lineIndex > 0 ? "mt-2" : ""}`}>
                          {line}
                        </p>
                      );
                    })}
                  </div>
                </div>
              </div>
            </Card>
          );
        })}
        
        <div className="flex justify-center pt-3">
          <Button 
            onClick={onNext} 
            className="w-full max-w-sm bg-primary hover:bg-primary/90 text-primary-foreground px-8 py-3 h-auto rounded-full"
          >
            {question.buttonText}
          </Button>
        </div>
      </div>
    </div>
  );
}